<template lang="pug">
.map-sidebar-sort-by
  AppSelectDropdown(
    :value="value"
    :options="options"
    @input="$emit('input', $event)"
  )
    span.m-0 Sort: {{ value.text }}
    template(#option="{ option }")
      span.p-0(:class="iconClass(option)")
        | {{ option.text }}
</template>

<script>
export default {
  name: 'ActivitiesLocationSortBy',
  props: {
    value: {
      type: [String, Number, Array, Object],
      default: null,
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    iconClass(option) {
      const icon = option.icon ? option.icon : option.id;

      return `is-${icon}`;
    },
  },
};
</script>
